<div id="wplc">
    <app-leasing></app-leasing>
</div>    
